export const currentVersion = 'VERSION'; // will be replaced by current tag in Gitlab CI
